import { fetchEngineeringPage } from "../services/contentApi";
import { ServicePageProvider, useServicePage, useServiceSection } from "./ServicePageContext";

export function EngineeringPageProvider({ children }) {
  return (
    <ServicePageProvider fetchPage={fetchEngineeringPage}>
      {children}
    </ServicePageProvider>
  );
}

export const useEngineeringPage = useServicePage;
export const useEngineeringSection = useServiceSection;
